/**
 * GridMap semantic rules: the optional mesh_library reference resolves, and a
 * GridMap without one is reported, since it is legal and renders nothing.
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { heldResource } from '../../../godot/scene/resourceLiteral.js';
import { armEmits, groundedArm, reportArm } from '../../../linter/ruleArms.js';
const arms = {
    missingMeshLibrary: groundedArm('gridmap-requires-mesh-library', {
        kind: 'engine-inert',
        at: 'grid_map.cpp:676',
        unused: 'every cell is skipped while the library is null, so the map draws nothing',
    }),
};
function checkGridMap(context) {
    const diagnostics = [];
    const { node } = context;
    // An absent mesh_library is valid in Godot, but the GridMap renders nothing.
    if (heldResource(node.rawProperties.mesh_library) === undefined) {
        reportArm(diagnostics, arms.missingMeshLibrary, node, 'GridMap has no mesh_library. It will render nothing and is not visible.');
    }
    return diagnostics;
}
const gridMapValidationRule = {
    meta: {
        name: 'valid-gridmap-resources',
        description: 'Flags a GridMap with no mesh_library, which renders nothing',
        category: 'validation',
        emits: armEmits(arms),
        applicableNodeTypes: ['GridMap'],
    },
    check: checkGridMap,
};
ruleRegistry.register(gridMapValidationRule);
//# sourceMappingURL=linter.js.map